import { render, staticRenderFns } from "./FMessageCounter.vue?vue&type=template&id=5990de80&"
import script from "./FMessageCounter.vue?vue&type=script&lang=js&"
export * from "./FMessageCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports